import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import config from '../../config';
import { isMobileOnly } from "react-device-detect";
import axios from 'axios';
import Spinner from 'react-bootstrap/Spinner'
import { History as history, Routes as routes } from '../../navigation';

import '../../css/SingleScreens/UserProfileEditScreen.css';

import { ValidatorUtils, StringUtils } from '../../utils';
import { UserActions, NavigationActions, ContextActions, PracticeActions } from '../../actions';
import { TitleBar, SingleScreenNavBar, Input, Button, Errors, ValidationCodeInput, Line, PhoneInput } from  '../../components'

class UserSignInCodeScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      phone_number: '',
      password_login: false,
      text_sent: '',
      sign_in_method: 'email',
      validation_code: '',
      validation_loading: false,
      email_password_loading: false,
    }
  }

  componentDidMount() {
    let screen_props = this.props.location && this.props.location.state && this.props.location.state.props ? this.props.location.state.props : null;
    if (screen_props) {
      let sign_in_method = screen_props && screen_props.sign_in_method ? screen_props.sign_in_method : 'email';
      let email          = screen_props && screen_props.email          ? screen_props.email        : '';
      let phone_number   = screen_props && screen_props.phone_number   ? screen_props.phone_number : '';
      let password_login = screen_props && screen_props.password_login ? screen_props.password_login : false;
      this.setState({ ...this.state, sign_in_method: sign_in_method, email: email, phone_number: phone_number, password_login: password_login });
    }
  }

  renderEmailCodeSection = (display) => {
    if (!display) {
      return null;
    }

    let validation_code = this.state.validation_code;
    let loading         = this.state.validation_loading;
    let width           = isMobileOnly ? 350 : '';

    return <div className="flex-container flex-container-column flex-center-align">
      <div className='instant-sign-in-container flex-container-column' style={{ height: 285, width: width }}>
        <div className='flex-container-row' style={{ justifyContent: 'space-between', padding: 15, paddingLeft: 15, paddingRight: 15, alignItems: 'flex-start' }}>
          <span className='fas fa-arrow-circle-left instant-back-button'
                style={{ fontSize: 30, marginTop: 5 }}
                onClick={ () => {
                  this.props.userActions.signOut();
                }} />
          <div className='flex-container-column' style={{ alignItems: 'center' }}>
            <span style={{ fontWeight: 'bold', fontSize: 22 }}>Account Sign-In Key</span>
            <span style={{ width: 210, height: 2, borderRadius: 2, backgroundColor: '#1dc2ff' }}></span>
            <span style={{ fontSize: 12, color: '#1dc2ff' }}>Please check your email for an Sign-In Key from TeleTails</span>
            <span style={{ fontSize: 12, color: '#1dc2ff' }}>{ this.state.email }</span>
          </div>
          <span className='fas fa-arrow-circle-left' style={{ fontSize: 30, color: 'white' }}></span>
        </div>

        <div className='flex-container-column' style={{ alignItems: 'center', marginTop: 15 }}>
          <ValidationCodeInput
            value={validation_code}
            style={{ width: 100, padding: 0, fontSize: 20, textAlign: 'center', marginBottom: 8 }}
            onChange={ (code) => { this.setState({ ...this.state, validation_code: code.toUpperCase() }) }}
            code_length={6}
            completeAction={ (code) => {
              this.validationAction(code);
              this.setState({ ...this.state, validation_code: code.toUpperCase() })
            }}
          />
          <div className='instant-join-session-button'
               onClick={ () => {
                 this.validationAction(this.state.validation_code);
               }}>
            { loading ? <Spinner as="span" animation="border" size='sm' style={{ color: 'white', marginRight: 8 }} />
                      : <span className='fas fa-check-circle' style={{ fontSize: 16, marginRight: 8 }}/> }
            <span style={{ fontWeight: 'bold', fontSize: 14 }}>Sign In With Key</span>
          </div>
          <div style={{ marginTop: 25 }}>
            <span style={{ fontSize: 12, color: 'grey'}}>Didn't receive a key?
            <span style={{ color: '#1dc2ff', marginLeft: 5 }}
                  className='instant-back-button'
                  onClick={ () => {
                    this.resendEmail();
                  }}>Resend Email</span>
          </span>
          </div>
        </div>

        <Line style={{ marginTop: 5 }} hide={!this.state.password_login} />

        { this.state.password_login ? <div className='flex-container-row' style={{ justifyContent: 'center', alignItems: 'center', height: 45, backgroundColor: 'white' }}>
          <div className='instant-back-button flex-container-column' style={{ fontSize: 12, flex: 1, color: '#1dc2ff', alignItems: 'center'  }}>
            <span onClick={ () => {
              this.setState({ ...this.state, sign_in_method: 'password' })
            }}>Sign In with Password</span>
          </div>
        </div> : null }

      </div>
    </div>
  }

  renderTextCodeSection = (display) => {
    if (!display) {
      return null;
    }

    let text_sent = this.state.text_sent;

    let validation_code = this.state.validation_code;
    let loading         = this.state.validation_loading;
    let phone_number    = this.state.phone_number;
    let phone_last_four = phone_number.length > 5 ? phone_number.substr(phone_number.length - 4) : '';
    let phone_text      = '***-***-' + phone_last_four;

    let display_phone_input = false;
    let button_title        = 'Sign In With Key';
    let button_icon         = 'fas fa-check-circle';
    let section_title       = display_phone_input ? 'Sign In With Text'  : 'Enter Sign-In Key';
    let sub_title           = display_phone_input ? 'You will receive a text message with your Sign-In Key'
                                                  : 'Please check your text messages for a Sign-In Key';
    let display_didnt_rcv   = display_phone_input ? false : true;

    return <div className="flex-container flex-container-column flex-center-align">
      <div className='instant-sign-in-container flex-container-column' style={{ height: 285 }}>
        <div className='flex-container-row' style={{ justifyContent: 'space-between', padding: 15, paddingLeft: 15, paddingRight: 15, alignItems: 'flex-start' }}>
          <span className='fas fa-arrow-circle-left instant-back-button'
                style={{ fontSize: 30, marginTop: 5 }}
                onClick={ () => {
                  this.props.userActions.signOut();
                }} />
          <div className='flex-container-column' style={{ alignItems: 'center' }}>
            <span style={{ fontWeight: 'bold', fontSize: 22 }}>{ section_title }</span>
            <span style={{ width: 210, height: 2, borderRadius: 2, backgroundColor: '#1dc2ff' }}></span>
            <span style={{ fontSize: 12, color: '#1dc2ff' }}>{ sub_title }</span>
            <span style={{ fontSize: 12, color: '#1dc2ff' }}>{ display_phone_input ? '' : phone_text }</span>
          </div>
          <span className='fas fa-arrow-circle-left' style={{ fontSize: 30, color: 'white' }}></span>
        </div>

        <div className='flex-container-column' style={{ alignItems: 'center', marginTop: 10 }}>

          { display_phone_input ? <span style={{ fontSize: 18, color: '#575757' }}>{ phone_text }</span>
                                : <ValidationCodeInput
                                      value={validation_code}
                                      style={{ width: 100, padding: 0, fontSize: 20, textAlign: 'center' }}
                                      code_length={6}
                                      onChange={ (code) => { this.setState({ ...this.state, validation_code: code.toUpperCase() }) }}
                                      completeAction={ (code) => {
                                        this.validationAction(code);
                                        this.setState({ ...this.state, validation_code: code.toUpperCase() })
                                      }}
                                    /> }

          <div className='instant-join-session-button'
               style={{ marginTop: 8 }}
               onClick={ () => {
                 if (display_phone_input) {
                   this.setState({ ...this.state, text_sent: true });
                 } else {
                   this.validationAction(this.state.validation_code);
                 }
               }}>
            { loading ? <Spinner as="span" animation="border" size='sm' style={{ color: 'white', marginRight: 8 }} />
                      : <span className={button_icon} style={{ fontSize: 16, marginRight: 8 }}/> }
            <span style={{ fontWeight: 'bold', fontSize: 14 }}>{ button_title }</span>
          </div>

          {display_didnt_rcv ? <div style={{ marginTop: 30 }}>
            <span style={{ fontSize: 12, color: 'grey'}}>Didn't receive a key?
            <span style={{ color: '#1dc2ff', marginLeft: 5 }}
                  className='instant-back-button'
                  onClick={ () => {
                    this.resendText();
                  }}>Resend Text</span>
            </span>
          </div> : null }

          <Line style={{ marginTop: 5 }} hide={!this.state.password_login} />

          { this.state.password_login ? <div className='flex-container-row' style={{ justifyContent: 'center', alignItems: 'center', height: 45, backgroundColor: 'white' }}>
            <div className='instant-back-button flex-container-column' style={{ fontSize: 12, flex: 1, color: '#1dc2ff', alignItems: 'center', paddingBottom: 3  }}>
              <span onClick={ () => {
                this.setState({ ...this.state, sign_in_method: 'password' })
              }}>Sign In with Password</span>
            </div>
          </div> : null }

        </div>

      </div>
    </div>
  }

  renderPasswordSection = (display) => {
    if (!display) {
      return null;
    }

    let loading = this.state.email_password_loading;
    let width   = isMobileOnly ? 350 : '';

    return <div className="flex-container flex-container-column flex-center-align">
      <div className='instant-sign-in-container flex-container-column' style={{ height: 245, width: width }}>
        <div className='flex-container-row' style={{ justifyContent: 'space-between', padding: 15, paddingLeft: 15, paddingRight: 15, alignItems: 'flex-start' }}>
          <span className='fas fa-arrow-circle-left instant-back-button'
                style={{ fontSize: 30, marginTop: 5 }}
                onClick={ () => {
                  this.props.userActions.signOut();
                }} />
          <div className='flex-container-column' style={{ alignItems: 'center' }}>
            <span style={{ fontWeight: 'bold', fontSize: 22 }}>Sign In With Password</span>
            <span style={{ width: 210, height: 2, borderRadius: 2, backgroundColor: '#1dc2ff' }}></span>
            <span style={{ fontSize: 12, color: '#1dc2ff' }}>Use your email and password to sign in</span>
          </div>
          <span className='fas fa-arrow-circle-left' style={{ fontSize: 30, color: 'white' }}></span>
        </div>

        <div className='flex-container-column' style={{ alignItems: 'center', marginTop: 15 }}>

          <Input style={{ marginBottom: 5, width: 250 }}
                 placeholder="Email"
                 className='instant-input-default'
                 value={this.state.email}
                 onChange={ (event) => { this.setState({ ...this.state, email: event.target.value }) }}
              />
          <Input style={{ marginBottom: 10, width: 250 }}
                 placeholder="Password"
                 type="password"
                 className='instant-input-default'
                 value={this.state.password}
                 onChange={ (event) => { this.setState({ ...this.state, password: event.target.value }) }}
              />

          <div className='instant-join-session-button'
               onClick={ () => {
                 if (this.state.email && this.state.password) {
                   this.emailPasswordLogin();
                 }
               }}>
            { loading ? <Spinner as="span" animation="border" size='sm' style={{ color: 'white', marginRight: 8 }} />
                      : <span className='fas fa-check-circle' style={{ fontSize: 16, marginRight: 8 }}/> }
            <span style={{ fontWeight: 'bold', fontSize: 14 }}>Sign In</span>
          </div>
        </div>

      </div>
    </div>
  }

  render() {
    const user = this.props.user && this.props.user.user ? this.props.user.user : null;
    return (
      <div className="flex-container flex-container-column flex-center-align">
        { this.renderEmailCodeSection(this.state.sign_in_method === 'email')   }
        { this.renderTextCodeSection(this.state.sign_in_method === 'text')     }
        { this.renderPasswordSection(this.state.sign_in_method === 'password') }
      </div>
    );
  }

  resendEmail = () => {
    let email = this.state.email;
    this.props.userActions.sendSignInCodeEmail(email, () => {  }, () => {  });
  }

  resendText = () => {
    let phone_number = this.state.phone_number;
    this.props.userActions.sendSignInCodeText(phone_number, () => {  }, () => {  });
  }

  validationAction = (code) => {
    let email        = this.state.sign_in_method === 'email' ? this.state.email : null;
    let phone_number = this.state.sign_in_method === 'text'  ? this.state.phone_number : null;
    this.props.userActions.codeSignIn(email, phone_number, code || this.state.validation_code, this.failureCallback);
    this.setState({ ...this.state, validation_loading: true });
  }

  emailPasswordLogin = () => {
    this.props.userActions.signIn(this.state.email, this.state.password, () => {  });
  }

  failureCallback = (message) => {
    this.setState({ ...this.state, validation_loading: false });
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    loading: state.loading,
    practice: state.practice,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserSignInCodeScreen)
